import { render, staticRenderFns } from "./QaSession.vue?vue&type=template&id=ed50f22e&scoped=true"
import script from "./QaSession.vue?vue&type=script&lang=js"
export * from "./QaSession.vue?vue&type=script&lang=js"
import style0 from "./QaSession.vue?vue&type=style&index=0&id=ed50f22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed50f22e",
  null
  
)

export default component.exports